/** Single identity allowed for site-owner-only admin features (e.g. newsletter lead export). */
export const SITE_OWNER_EMAIL = "matt@learnpdi.com";
